import { useRouter } from 'next/router';

import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbSeparator,
} from '@playbooks/ui/components/breadcrumb';
import { cn } from '@playbooks/ui/lib/utils';

import { dashToString } from 'utils';

const DocsBreadcrumbs = ({ className }: { className?: string }) => {
	const router = useRouter();
	const paths = router.asPath.split('?')[0].split('#')[0].split('/').filter(Boolean);

	// Theme
	const rootClassName = cn('mb-6', className);

	// Render
	return (
		<Breadcrumb className={rootClassName}>
			<BreadcrumbList>
				<BreadcrumbItem>
					<BreadcrumbLink href='/'>Docs</BreadcrumbLink>
				</BreadcrumbItem>
				{paths.map((path, index) => {
					const current = index === paths.length - 1;
					const href = `/${paths.slice(0, index + 1).join('/')}`;
					return (
						<BreadcrumbItem key={href}>
							<BreadcrumbSeparator />
							<BreadcrumbLink href={href} aria-current={current ? 'page' : undefined}>
								{dashToString(path)}
							</BreadcrumbLink>
						</BreadcrumbItem>
					);
				})}
			</BreadcrumbList>
		</Breadcrumb>
	);
};

export { DocsBreadcrumbs };
